import { FC } from 'react'

import styles from '../../styles.module.scss'

type Props = {
  chatOpen: boolean
  setChatOpen: (chatOpen: boolean) => void
  unreadMessagesTotal: number
}
const ChatTrigger: FC<Props> = ({ chatOpen, setChatOpen, unreadMessagesTotal }) => {
  return (
    <div className={`btn ${styles.triggerButton} ${chatOpen && 'd-none d-sm-flex'}`} onClick={() => setChatOpen(!chatOpen)}>
      <span className={styles.notification}>{unreadMessagesTotal}</span>
      <i className={`fas fa-2x fa-comments ${chatOpen ? styles.triggerButtonOpenInactive : styles.triggerButtonOpenActive} ${styles.triggerButtonIcon}`}></i>
      <i className={`fas fa-2x fa-times ${chatOpen ? styles.triggerButtonCloseActive : styles.triggerButtonCloseInactive} ${styles.triggerButtonIcon}`}></i>
    </div>
  )
}

export { ChatTrigger }
